import { AxiosError, AxiosResponse, CanceledError } from 'axios'

import { faultKickOut, clearCacheWorkspce } from '@/utils/utils'
import { navigatePage, PageAlias } from '@/utils/pageRouter'
import { createRequestKey, pendingRequest } from './utils'
import logger from '../logger'
import i18n from '@/services/i18n'
import { ExcelBoldModel, ResponseModel } from './models'
import emitter from '@/utils/event'
import { NO_PERMISSION_EVENT } from '@/constants/event'
import { ErrorCodeTypeEnum } from '../apis/policy/model'

// 不全局报错的白名单和code码
const WhiteUrllist = ['/policy/addressbook/add', '/policy/addressbook/update']
const WhiteCodelist = [
  ErrorCodeTypeEnum.NAMEDUPLICATION,
  ErrorCodeTypeEnum.ADRESSDUPLICATION,
  ErrorCodeTypeEnum.FORMATERROR,
]
const handleResponse = async (axiosResponse: AxiosResponse) => {
  if (axiosResponse.headers['content-type']?.includes('application/vnd.ms-excel')) {
    const res: ResponseModel<ExcelBoldModel> = {
      success: true,
      errMsg: '',
      code: '200',
      data: {
        length: axiosResponse.headers['content-lenght'],
        filename: '',
        data: axiosResponse.data,
      },
    }
    return res
  }
  // 下载文件处理处理，复制的vue项目代码
  if (axiosResponse.config.url?.includes('attachement/getUrl')) {
    if (axiosResponse.headers['content-type'].includes('application/octet-stream')) {
      return {
        success: true,
        code: '200',
        data: axiosResponse.data,
      }
    }

    const reader = new FileReader()
    reader.onload = e => {
      try {
        // @ts-ignore
        const json = JSON.parse(e.target.result)
        window.shMessage.error(json.message)
        return { success: false }
      } catch (error) {}
    }
    reader.readAsText(axiosResponse.data)
  }
  const { data } = axiosResponse

  // 这一行是兼容东哥的代码
  if (
    !Object.prototype.hasOwnProperty.call(data, 'success') &&
    !Object.prototype.hasOwnProperty.call(data, 'isSuccess')
  ) {
    data.success = data.code === 200
  }
  // 这一行是兼容亮哥的返回结果
  data.success = data.success || data.isSuccess
  // 这一行兼容东哥的代码
  data.errMsg = data.errMsg || data.message || data.err_msg

  if (!data.success) {
    // 不返回全局错误的白名单 需要特定url和特定code同时满足
    if (
      axiosResponse.config.url &&
      WhiteUrllist.includes(axiosResponse.config.url) &&
      WhiteCodelist.includes(data.code)
    ) {
      return data
    }
    switch (data.code) {
      case 400:
        faultKickOut()
        break
      case 403:
        clearCacheWorkspce()
        navigatePage(PageAlias.home)
        break
      case 1006:
        if (emitter.has(NO_PERMISSION_EVENT)) {
          emitter.emit(NO_PERMISSION_EVENT)
        } else {
          data.errMsg && window.shMessage.error(data.errMsg)
        }
        break
      default:
        data.errMsg && window.shMessage.error(data.errMsg)
        break
    }
  }
  return data
}

const handleGlobalError = (error: AxiosError) => {
  if (error instanceof CanceledError) {
    logger.debug('a request was actively aborted')
    return {
      success: false,
      errMsg: 'request canceled',
    }
  }
  logger.error(error.message)
  const errorResult = {
    success: false,
    data: null,
    code: -999,
    errMsg: i18n.t('network.errMsg'),
  }
  window.shMessage.error(errorResult.errMsg)
  return errorResult
}

const handlePendingRequestMap = (axiosResponse: AxiosResponse) => {
  const { config } = axiosResponse
  const requestKey = createRequestKey(config)
  pendingRequest.delete(requestKey)
  logger.debug('pending request', pendingRequest)
  return axiosResponse
}

export { handleResponse, handleGlobalError, handlePendingRequestMap }
